import client from './client'

export default {
  create ({ email, optInConsentHintId, code, query }) {
    const body = {
      code: code,
      q: query,
      variant: 'fused',
      opt_in_consent_hint_id: optInConsentHintId,
      account: { email: email }
    }

    return client.post('/api/registrations.json', { json: body }).json()
  },

  latestOptInConsentHint () {
    return client.get('/api/latest_opt_in_consent_hint.json').json()
  }
}
